module.exports = __webpack_public_path__ + "assets/208424d2fd811bc1cd1df6817715cdfb-DSC_0801 - kopie.jpg";